import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useCooldown } from "./useCooldown";
import { usePasswordRecovery } from "./usePasswordRecovery";
import { PasswordRecoveryFormProps } from "./types";

export const PasswordRecoveryForm = ({ onBack, onTokenRecovery }: PasswordRecoveryFormProps) => {
  const [email, setEmail] = useState("");
  const { cooldown, setCooldownWithStorage } = useCooldown();
  const { isLoading, handlePasswordRecovery } = usePasswordRecovery(setCooldownWithStorage);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handlePasswordRecovery(email, cooldown);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-white mb-4">Recuperar contraseña</h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-white">
            Correo electrónico
          </Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            required
            className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
          />
        </div>
        <div className="space-y-4">
          <Button
            type="submit"
            className="w-full bg-clubbers-red hover:bg-clubbers-red/90"
            disabled={isLoading || cooldown > 0}
          >
            {isLoading 
              ? "Enviando..." 
              : cooldown > 0 
                ? `Espera ${cooldown}s` 
                : "Enviar instrucciones"}
          </Button>
          <Button
            type="button"
            variant="ghost"
            onClick={onTokenRecovery}
            className="w-full text-white hover:bg-white/10"
          >
            Ya tengo un código de recuperación
          </Button>
          <Button
            type="button"
            variant="ghost"
            onClick={onBack}
            className="w-full text-white hover:bg-white/10"
          >
            Volver al inicio de sesión
          </Button>
        </div>
      </form>
    </div>
  );
};